import React, { MouseEventHandler, PropsWithChildren, ReactNode } from "react";
import classNames from "classnames";

import HotKey from "components/HotKey";

import styles from "./search.module.css";

type SearchItemProps = {
  href?: string;
  textStyle?: "normal" | "danger";
  icon: ReactNode;
  hoverableId: string;
  currentlyFocussedId: string | undefined | null;
  onClick?: MouseEventHandler;
};

const SearchItem: React.FC<PropsWithChildren<SearchItemProps>> = ({
  href,
  children,
  textStyle = "normal",
  icon,
  hoverableId,
  currentlyFocussedId,
  onClick,
}) => {
  return (
    <a
      href={href}
      className={classNames(styles.searchItem, {
        [styles.focussed]: currentlyFocussedId === hoverableId,
        [styles.danger]: textStyle === "danger",
      })}
      data-hoverable-id={hoverableId}
      onClick={onClick}
    >
      {icon}
      <span>{children}</span>
      {currentlyFocussedId === hoverableId && <HotKey right={8} char="↵" />}
    </a>
  );
};

export default SearchItem;
